import { render, staticRenderFns } from "./ApplicantShowDocuments.vue?vue&type=template&id=d560f2ee&"
import script from "./ApplicantShowDocuments.vue?vue&type=script&lang=js&"
export * from "./ApplicantShowDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports